<template>
  <div class="box">
    <div class="title">
      <span class="titleline"></span>
      <span class="titletext">咨询记录</span>
      <div class="buttontop">
        <el-button type="warning" size="small" @click="consultationPreview">预览</el-button>
        <el-button type="primary" size="small" @click="download">打印</el-button>
      </div>
    </div>
    <div class="table">
      <el-table ref="itemTable" :data="tableData" size="mini" :stripe="true" border :selectable="checkboxT"
                style="width: 100%" :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'font-size': '14px' }" @selection-change="sonsultationSelect">
        <el-table-column type="selection" label="选择" width="50" align="center"></el-table-column>
        <el-table-column prop="consultDesc" label="交流记录" align="left">
          <template slot-scope="scope">
            <div style="font-size: 14px" v-if="scope.$index === 0 || scope.$index === 1 || scope.$index === 2">
              {{ scope.row.consultName }}： {{ scope.row.consultDesc }}
            </div>
            <div style="font-size: 14px" v-if="scope.$index === 3" class="edit">
              <div>备注：{{ scope.row.consultRemarks }}</div>
              <div>
                <el-button type="text" style="font-size: 14px" @click="eiditConsultRemarks(scope.row)"
                           v-if="scope.$index === 3">编辑
                </el-button>
              </div>
            </div>
            <div v-if="![0, 1, 2, 3].includes(scope.$index)" style="font-size: 14px" class="edit">
              <div>{{ scope.row.consultName }} {{ scope.row.createTime }}</div>
              <div>
                <el-button v-if="![0, 1, 2, 3].includes(scope.$index) &&
                  scope.row.approve == 0
                  " type="text" style="font-size: 14px; margin-left: 20px" @click="setApprove(scope.row.id, 1)"
                           v-permission="'400103'">设置可见
                </el-button>
                <el-button v-if="![0, 1, 2, 3].includes(scope.$index) &&
                  scope.row.approve == 1
                  " type="text" style="font-size: 14px; margin-left: 20px" @click="setApprove(scope.row.id, 0)"
                           v-permission="'400103'">设置不可见
                </el-button>
                <el-button type="text" style="font-size: 14px" @click="eiditConsult(scope.row)"
                           v-if="![0, 1, 2, 3].includes(scope.$index)">编辑
                </el-button>
                <el-button v-if="![0, 1, 2, 3].includes(scope.$index)" type="text"
                           style="color: #f56c6c; font-size: 14px"
                           @click="deleteServiceOneToOneConsult(scope.row.id)" v-permission="'400104'">删除
                </el-button>
              </div>
            </div>
            <div style="
                white-space: pre-line;
                font-size: 14px;
                border-top: 1px solid #e6e6e6;
              " v-html="scope.row.consultDesc" :disabled="scope.row.approve == 0 ? false : true"
                 v-if="![0, 1, 2, 3].includes(scope.$index)"></div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="div">
      咨询记录
      <richText @content="getContent" :contented="consultDesc"/>
    </div>
    <div class="div">
      快速录入
      <el-button type="primary" v-for="item in list" :key="item.consultName" @click="add(item)" size="small" plain>
        {{ item.consultName }}
      </el-button>
    </div>
    <el-button type="primary" size="small" style="width: 350px; margin-left: 150px"
               @click="saveServiceOneToOneConsult(consultDesc, 0)" v-permission="'400102'">保存咨询记录
    </el-button>
    <div class="title">
      <span class="titleline"></span>
      <span class="titletext">推荐专业</span>
      <div class="addbutton">
        <el-button type="primary" size="small" @click="setVisibleSpecialty()" v-permission="'400107'"
                   v-if="serviceOneToOneInfo.visibleSpecialty === -1">设置可见
        </el-button>
        <el-button size="small" @click="setVisibleSpecialty()" v-permission="'400107'"
                   v-if="serviceOneToOneInfo.visibleSpecialty === 1">设置不可见
        </el-button>
        <el-button type="primary" size="small" @click="selectSpecialtyList" v-permission="'400107'">添加专业</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :stripe="true" size="mini" :data="majortableData" border style="width: 100%"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="disciplineName" label="专业类别" width="140">
        </el-table-column>
        <el-table-column label="专业名称">
          <template slot-scope="scope">
            <div class="divspecialtys">
              <span v-for="(item, index) in scope.row.specialtys" :key="index" class="spanspecialtys">{{
                  item.specialtyName
                }}
                <i class="el-icon-close" @click="deleteServiceOneToOneSpecialty(item.id)"
                   v-permission="'400108'"></i></span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <div v-if="scope.row.approve == 0">待审核</div>
            <div v-if="scope.row.approve == 1">已审核</div>
            <div v-if="scope.row.approve == 2">已拒绝</div>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" style="color: #f56c6c; font-size: 14px" @click="
              deleteServiceOneToOneSpecialtyType(scope.row.disciplineId)
              ">删除
            </el-button>
            <el-button type="text" style="color: #f56c6c; font-size: 14px" v-if="scope.row.approve === 0">审核
            </el-button>
            <el-button type="text" style="color: #f56c6c; font-size: 14px" v-if="scope.row.approve === 1">取消审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="title" style="margin-top: 40px">
      <span class="titleline"></span>
      <span class="titletext">推荐院校</span>
      <div class="addbutton">
        <el-button type="primary" size="small" @click="setvisibleUniversity()" v-permission="'400107'"
                   v-if="serviceOneToOneInfo.visibleUniversity === -1">设置可见
        </el-button>
        <el-button size="small" @click="setvisibleUniversity()" v-permission="'400107'"
                   v-if="serviceOneToOneInfo.visibleUniversity === 1">设置不可见
        </el-button>
        <el-button type="primary" size="small" @click="selectCollegeList1()" v-permission="'400105'">添加院校
        </el-button>
      </div>
    </div>
    <div class="table">
      <el-table :stripe="true" size="mini" :data="schooltableData" border style="width: 100%"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="name" label="批次" width="140">
        </el-table-column>
        <el-table-column label="推荐院校">
          <template slot-scope="scope">
            <div class="divspecialtys">
              <span v-for="(item, index) in scope.row.data" :key="index" class="spanspecialtys">{{ item.collegeName }}
                <i class="el-icon-close" @click="deleteServiceOneToOneUniversity(item.id)"
                   v-permission="'400106'"></i></span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <div v-if="scope.row.approve == 0">待审核</div>
            <div v-if="scope.row.approve == 1">已审核</div>
            <div v-if="scope.row.approve == 2">已拒绝</div>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button style="color: #f56c6c" type="text" size="mini"
                       @click="deleteServiceOneToOneUniversityByAdmitBatch(scope.row)" v-permission="'400106'">删除
            </el-button>
            <el-button type="text" style="color: #f56c6c; font-size: 14px" v-if="scope.row.approve == 0">审核
            </el-button>
            <el-button type="text" style="color: #f56c6c; font-size: 14px" v-if="scope.row.approve == 1">取消审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 高校 -->
    <el-dialog title="添加院校" :visible.sync="dialogTableVisible1" width="96%" z-index="9999">
      <div class="el-dialog-div">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item>
            <el-button size="small" type="info" disabled>{{
                userform.examProvince
              }}
            </el-button>
          </el-form-item>
          <el-form-item label="科别:">
            <el-select v-model="formInline.disciplineType" placeholder="不限" size="small"
                       style="width: 100px; margin-right: 10px">
              <el-option v-for="item in disciplineTypeoptions" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次:">
            <el-select v-model="formInline.admitBatch" placeholder="不限" size="small" @change="changeadmitBatch()"
                       style="width: 140px; margin-right: 10px">
              <el-option v-for="item in batchs" :key="item.batch" :label="item.batch" :value="item.batch">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="高校省份:">
            <el-select v-model="formInline.collegeProvince" placeholder="不限" clearable size="small"
                       style="width: 100px; margin-right: 10px">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院校特性:">
            <el-select clearable multiple v-model="collegeCharacter" placeholder="不限" @change="changecollegeCharacter"
                       size="small" style="width: 100px; margin-right: 10px">
              <el-option v-for="item in optionsCharacter" :key="item.value" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分段:">
            <el-input clearable v-model="formInline.scoreMin" placeholder="最低分" size="small"
                      style="width: 90px; margin-right: 10px"></el-input>
            -
            <el-input clearable v-model="formInline.scoreMax" placeholder="最高分" size="small" style="width: 90px">
            </el-input>
          </el-form-item>
          <el-form-item label="位次:">
            <el-input clearable v-model="formInline.accumulateMin" placeholder="最低位" size="small"
                      style="width: 90px; margin-right: 10px"></el-input>
            -
            <el-input clearable v-model="formInline.accumulateMax" placeholder="最高位" size="small"
                      style="width: 90px">
            </el-input>
          </el-form-item>
          <el-form-item label="高校:">
            <el-input clearable v-model="formInline.keyWord" placeholder="请输入高校名称" size="small"
                      style="width: 140px">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="selectCollegeList()">搜索</el-button>
            <el-button size="small" type="primary" @click="saveServiceOneToOneUniversity">确定</el-button>
          </el-form-item>
        </el-form>
        <!-- @selection-change="handleSelectionChangeschool" -->
        <el-table :stripe="true" size="mini" :data="gridData1" :height="tableHeigth" border ref="eltableCurrentRow"
                  @select="selectschool" @row-click="btn"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
          <el-table-column type="selection" label="选择" width="80"></el-table-column>
          <el-table-column prop="collegeName" label="院校名称" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="collegeCity" label="所在城市"></el-table-column>
          <el-table-column prop="admitBatch" label="录取批次"></el-table-column>
          <el-table-column prop="scoreYearThis" :label="admissionYear + '最低分'" width="120"></el-table-column>
          <el-table-column prop="accumulateYearThis" :label="admissionYear + '最低位次'" width="120"></el-table-column>
          <el-table-column prop="scoreYearLast" :label="admissionYear - 1 + '最低分'" width="120"></el-table-column>
          <el-table-column prop="accumulateYearLast" :label="admissionYear - 1 + '最低位次'"
                           width="120"></el-table-column>
          <el-table-column prop="accumulateYearOther" :label="admissionYear - 2 + '最低位次'"
                           width="120"></el-table-column>
          <el-table-column prop="planYearThis" :label="planYear + '计划数'" width="120"></el-table-column>
          <el-table-column prop="planYearLast" :label="planYear - 1 + '计划数'" width="120"></el-table-column>
          <el-table-column prop="planDiff" label="计划增减" width="120"></el-table-column>
        </el-table>

        <el-pagination style="margin-top:10px" background layout="prev, pager, next" :total="recommendCollegeTotal"
                       @current-change="handleChange" :current-page.sync="formInline.current"
                       :page-size="formInline.size">
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 专业 -->
    <el-dialog title="添加专业" :visible.sync="dialogTableVisible" width="50%" z-index="9999">
      <div>
        <el-tree ref="tree" :style="{
          width: '100%',
          height: '500px',
          overflow: 'auto',
          display: 'inline-block',
        }" :data="data" show-checkbox node-key="specialtyId" :default-checked-keys="checkes" :props="defaultProps1"
                 :check-on-click-node="true" :expand-on-click-node="false" @check-change="handleCheckChange"></el-tree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="saveServiceOneToOneSpecialty">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑咨询记录" :visible.sync="dialogFormVisible" width="70%" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="咨询记录" label-width="120px">
          <richText @content="editCousultGetContent" :contented="editconsultDesc"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveServiceOneToOneConsult(editconsultDesc, 1)" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑备注" :visible.sync="dialogFormVisible1" z-index="9999">
      <el-form>
        <el-form-item label="备注" label-width="120px">
          <el-input v-model="consultRemarks" type="textarea" style="width: 600px" :rows="8"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="sureeiditConsultRemarks">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import richText from "@/components/richText";
import wangEditor from "@/components/wangEditor";
import {
  deleteServiceOneToOneConsult,
  deleteServiceOneToOneSpecialty,
  deleteServiceOneToOneSpecialtyType,
  deleteServiceOneToOneUniversity,
  deleteServiceOneToOneUniversityByAdmitBatch,
  getOneProvince,
  getServiceConsultPage,
  getServiceOneToOneConsult3,
  getServiceOneToOneConsultPage,
  getServiceOneToOneInfo,
  getServiceOneToOneSpecialtyList,
  getServiceOneToOneUniversityPage,
  getSpecialtyTree,
  saveServiceOneToOneConsult,
  saveServiceOneToOneSpecialty,
  saveServiceOneToOneUniversity,
  selectCollegeList,
  setApprove,
  setVisibleSpecialty,
  setvisibleUniversity,
  updateConsultRemarks,
} from "@/api/serviceManagement.js";
import axios from "@/util/request";
import lpyMixin from "@/mixin/lpyMixin";
import {getProvinceList} from "@/api/index.js";

export default {
  mixins: [lpyMixin],
  props: {
    userform: {
      Type: Object,
      default: () => {
      },
    },
    oneId: {
      Type: String,
      default: "",
    },
    orderId: {
      Type: String,
      default: "",
    },
  },
  components: {
    richText,
    wangEditor
  },
  data() {
    return {
      serviceOneToOneInfo: {},
      data: [],
      checkes: [],
      consultRemarks: "",
      dialogFormVisible1: false,
      editconsultDesc: "",
      dialogFormVisible: false,
      idList: [],
      disciplineTypeoptions: [
        {label: "不分文理", value: 0},
        {label: "理科", value: 1},
        {label: "文科", value: 2},
        {label: "物理类", value: 3},
        {label: "历史类", value: 4},
      ],
      textarea: "",
      tableData: [],
      optionsCharacter: [
        {label: "211", value: "1"},
        {label: "985", value: "2"},
        {label: "双一流", value: "3"},
        {label: "国重点", value: "4"},
        {label: "省重点", value: "5"},
        {label: "保研资格", value: "6"}
      ],
      options: [],
      options1: [],
      collegeCharacter: [],
      yearoptions: [],
      dialogTableVisible1: false,
      dialogTableVisible: false,
      schooltableData: [],
      majortableData: [],
      schoolids: [],
      list: [],
      user: {},
      form: {},
      defaultProps1: {
        children: "specialtyList",
        label: "specialtyName",
      },
      consultDesc: "",
      remarks: "", //备注
      id: "",
      formInline: {
        size: 500,
        current: 1,
        collegeProvinceId: "",
        provinceId: "",
        admitBatch: "",
        collegeCharacter: "",
        disciplineType: null,
      },
      recommendCollegeTotal: 0,
      // formInline1: { size: 500 },
      gridData1: [],
      gridData: [],
      year: "",
      school: [],
      specialty: [],
      batch: "",
      batchs: [],
      chooseSpecialty: [],
      oneid: "",
      idOrder: "",
      admissionYear: new Date().getFullYear(),
      planYear: new Date().getFullYear()
    };
  },
  watch: {
    userform: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.user = newValue;
        // this.year = newValue.graduateYear;
        // this.formInline.collegeProvinceId = this.user.province;
        this.getOneProvince(newValue.graduateYear, this.user.province);
        // this.selectCollegeList();
        // this.selectSpecialtyList();
      },
      deep: true,
    },
    oneId: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.id = newValue;
        this.form.oneId = newValue;
        this.oneid = newValue;
        console.log(this.id, "this.id");
        if (this.id) {
          this.getyear();
          this.getServiceOneToOneConsultPage(this.id);
          this.getServiceOneToOneUniversityPage(this.id);
          this.getServiceOneToOneSpecialtyList(this.id);
          this.getServiceOneToOneInfo();
        }
      },
      deep: true,
    },
    orderId: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.idOrder = newValue;
      },
      deep: true,
    },
  },
  mounted() {
    this.getServiceConsultPage();
    this.getProvinceList();
    this.getServiceOneToOneInfo();
    this.getyear();
  },
  methods: {
    // 获取年份
    getyear() {
      let date = new Date();
      let year = date.getFullYear();
      this.year = 2021;
    },
    getContent(content) {
      this.consultDesc = content;
    },
    editCousultGetContent(content) {
      console.log(content, "富文本内容")
      this.editconsultDesc = content;
    },
    checkboxT(row, rowIndex) {
      if (rowIndex == 2) {
        return false;
      }
    },
    btn(row, col, event) {
      console.log('点击');
      row.flag = !row.flag;
      let flag = null;
      if (this.schoolids.includes(row.collegeName)) {
        flag = false;
      } else {
        flag = true;
      }
      this.$refs.eltableCurrentRow.toggleRowSelection(row, flag);
      if (this.schoolids.includes(row.collegeName)) {
        this.schoolids.splice(this.schoolids.indexOf(row.collegeName), 1);
        this.school = this.school.filter(function (item) {
          return item.collegeName != row.collegeName;
        });
      } else {
        this.schoolids.push(row.collegeName);
        this.school.push(row);
      }
      console.log(this.school, 'this.school');
    },
    selectschool(data, val) {
      if (this.schoolids.indexOf(val.collegeName) != -1) {
        this.schoolids.splice(this.schoolids.indexOf(val.collegeName), 1);
        this.school = this.school.filter(function (item) {
          return item.collegeName != val.collegeName;
        });
      } else {
        this.schoolids.push(val.collegeName);
        this.school.push(val);
      }
      console.log(this.schoolids, "this.schoolids");
      console.log(this.school, "this.school");
    },

    sonsultationSelect(val) {
      this.idList = [];
      val.forEach((item) => {
        this.idList.push(item.id);
      });
    },
    //下载咨询记录
    // 导出
    download() {

      let data = {oneId: this.oneid, idList: this.idList};
      // let data = { oneId: this.oneid };
      axios({
        method: "post",
        url: "/com/had-login/service-one-to-one-consult/downloadWord",
        data: data,
        responseType: "blob",
      })
          .then((res) => {
            const elink = document.createElement("a");
            elink.download = `${this.user.realName}-咨询记录.docx`; //定义表格名称，后缀是文件格式
            elink.style.display = "none";
            const blob = new Blob([res], {
              type: "application/msword",
            });
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          })
          .catch((err) => {
            console.log(err);
          });
    },
    filterambitTypes(data) {
      switch (data) {
        case 0:
          return "不限";
        case 1:
          return "综合";
        case 2:
          return "理工";
        case 3:
          return "文史";
        case 4:
          return "师范";
        case 5:
          return "教育";
        case 6:
          return "财经";
        case 7:
          return "艺术";
        case 8:
          return "农林";
        case 9:
          return "军事";
        case 10:
          return "政法";
        case 11:
          return "医药";
        case 12:
          return "体育";
        case 13:
          return "预科";
        case 20:
          return "其他";
        default:
          return data;
      }
    },
    changecollegeCharacter(val) {
      console.log(val, "val");
      this.formInline.collegeCharacter = val.join(",");
    },
    //咨询预览
    consultationPreview() {
      let routeData = this.$router.resolve({
        path: "/consultationPreview",
        query: {
          oneId: this.oneid,
          studentId: this.user.studentId,
          orderId: this.idOrder,
          idList: this.idList,
        },
      });
      window.open(routeData.href, "_blank");
    },
    eiditConsult(data) {
      console.log(data, "data");
      this.form = data;
      this.editconsultDesc = this.form.consultDesc;
      this.consultRemarks = this.form.consultRemarks;
      this.dialogFormVisible = true;
    },
    getAllNode(arr, name, childName) {
      const arrs = [];
      if (!arr) {
        return;
      }
      if (!name) {
        name = "id";
      }
      if (!childName) {
        childName = "children";
      }
      arr = Object.assign([], arr);
      console.log(arr, "arr");
      if (arr) {
        const getChild = (arr) => {
          arr = Object.assign([], arr);
          // JSON.Parse( JSON.stringify(arr) )
          console.log(arr, "arr2");
          for (let i = 0; i < arr.length; i++) {
            if (arr[i][name] === true) {
              arrs.push(arr[i].companyId);
            }
            if (arr[i][childName] && arr[i][childName].length > 0) {
              getChild(arr[i][childName]);
            }
          }
          return arrs;
        };
        return getChild(arr);
      }
    },
    handleCheckChange(data, checked, indeterminate) {
      let arr = this.$refs.tree.getCheckedNodes();
      this.chooseSpecialty = [];
      arr.forEach((item) => {
        if (!item.specialtyList) {
          this.chooseSpecialty.push(item);
        }
      });
      console.log(this.$refs.tree.getCheckedNodes()), "123";
    },
    getProvinceList() {
      getProvinceList({}).then((res) => {
        if (res.code == 1) {
          this.options1 = res.data || [];
          this.options1.unshift({name: "不限", label: ""});
        }
      });
    },
    getServiceOneToOneInfo() {
      //console.log('this.this.oneidthis.oneidthis.oneidthis.oneidthis.oneid',this.oneid)
      getServiceOneToOneInfo({oneId: this.oneid}).then((res) => {
        if (res.code == 1) {
          this.serviceOneToOneInfo = res.data || {};
        }
      });
    },
    setVisibleSpecialty() {
      //console.log('this.this.oneidthis.oneidthis.oneidthis.oneidthis.oneid',this.oneid)
      setVisibleSpecialty({oneId: this.oneid}).then((res) => {
        if (res.code == 1) {
          this.getServiceOneToOneInfo();
        }
      });
    },
    setvisibleUniversity() {
      // console.log('this.this.oneidthis.oneidthis.oneidthis.oneidthis.oneid',this.oneid)
      setvisibleUniversity({oneId: this.oneid}).then((res) => {
        if (res.code == 1) {
          this.getServiceOneToOneInfo();
        }
      });
    },
    //审核
    setApprove(id, approve) {
      setApprove({approve: approve, id: id}).then((res) => {
        if (res.code == 1) {
          this.getServiceOneToOneConsultPage(this.id);
        }
      });
    },
    //获取批次
    getOneProvince(year, areaProvinceId) {
      getOneProvince({year: year, areaProvinceId: areaProvinceId}).then(
          (res) => {
            let data = res.data || {};
            let planDate = data.planDate
            planDate = new Date(planDate).getTime()

            if (new Date().getTime() < planDate) {
              this.getOneProvince(year - 1, areaProvinceId)
            } else {
              let batchs = data.batchs || [];
              this.batchs = batchs || [];
              if (batchs.length > 0) {
                this.batch = batchs[0].batch || "";
                for (let i = 0; i < batchs.length; i++) {
                  if (batchs[i].batchType === 2) {
                    this.batch = batchs[i].batch || "";
                    break;
                  }
                }
              }
            }
          }
      );
    },
    //快速录入
    add(data) {
      console.log(data);
      if (this.consultDesc) {
        this.consultDesc = `${this.consultDesc}\n${data.consultDesc}`;
      } else {
        this.consultDesc = `${data.consultDesc}`;
      }
    },
    //删除咨询记录
    deleteServiceOneToOneConsult(id) {
      this.$confirm("确定要删除该条咨询记录吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            deleteServiceOneToOneConsult({id: id}).then((res) => {
              this.getServiceOneToOneConsultPage(this.id);
            });
          })
          .catch(() => {
          });
    },
    // handleSelectionChangeschool(data,val) {
    //   console.log(data,'data');
    //   console.log(val,'val');
    //     this.school = val;
    // },
    //保存咨询记录
    saveServiceOneToOneConsult(data, iseidt) {
      this.form.consultDesc = this.consultDesc;
      this.form.consultName = this.user.realName;
      if (data) {
        this.form.consultDesc = data;
      }
      if (!this.form.consultDesc) {
        this.$message.error("请输入咨询记录内容");
        return;
      }
      if (!iseidt) {
        this.form.id = null;
      }
      console.log(this.form.consultDesc, "咨询内容");
      saveServiceOneToOneConsult(this.form).then((res) => {
        if (res.code == 1) {
          this.getServiceOneToOneConsultPage(this.id);
          this.consultDesc = "";
          this.editconsultDesc = "";
          this.remarks = "";
          this.dialogFormVisible = false;
          this.form = {};
          this.form.oneId = this.oneid;
        }
      });
    },
    //获取咨询记录
    getServiceOneToOneConsultPage(id) {
      getServiceOneToOneConsultPage({oneId: id, current: 1, size: 1000}).then((res) => {
        console.log(res, "咨询记录");
        let data = res.data || {};
        this.tableData = data.records || [];
        this.tableData.unshift({
          consultRemarks: data.consultRemarks ? data.consultRemarks : "",
        });
        getServiceOneToOneConsult3({oneId: id}).then((res) => {
          if (res.code == 1) {
            let data = res.data || [];
            // if(data.length > 2){
            this.tableData.unshift(...data);

            // }else{
            // this.tableData.unshift({consultName: "兴趣结果",consultDesc: ""},{consultName: "性格结果",consultDesc: ""},{consultName: "能力结果",consultDesc: ""})
            // }
          }
          if (data && data.length > 0) {
            this.$nextTick(function () {
              this.$refs.itemTable.toggleRowSelection(
                  this.tableData[this.tableData.length - 1],
                  true
              );
            });
          }
        });
      });
    },
    // 显示编辑备注
    eiditConsultRemarks(data) {
      this.dialogFormVisible1 = true;
      this.consultRemarks = data.consultRemarks;
    },
    sureeiditConsultRemarks() {
      if (!this.consultRemarks) {
        this.$message.error("请输入备注内容");
        return;
      }
      updateConsultRemarks({
        oneId: this.id,
        consultRemarks: this.consultRemarks,
      }).then((res) => {
        if (res.code == 1) {
          this.getServiceOneToOneConsultPage(this.id);
          this.consultRemarks = "";
          this.dialogFormVisible1 = false;
        }
      });
    },
    //获取快速录入
    getServiceConsultPage() {
      getServiceConsultPage({
        current: 1,
        size: 1000
      }).then((res) => {
        console.log(res, "res");
        let data = res.data || {};
        this.list = data.records || [];
      });
    },
    // 删除批次
    deleteServiceOneToOneUniversityByAdmitBatch(data) {
      deleteServiceOneToOneUniversityByAdmitBatch({
        oneId: this.id,
        admitBatch: data.name,
      }).then((res) => {
        if (res.code == 1) {
          this.getServiceOneToOneUniversityPage(this.form.oneId);
        }
      });
    },
    //获取高校
    getServiceOneToOneUniversityPage(id) {
      this.school = [];
      getServiceOneToOneUniversityPage({oneId: id}).then((res) => {
        if (res.code == 1) {
          console.log(res, "高校");
          let data = res.data || {};
          this.schooltableData = [];
          for (let i in data) {
            this.schooltableData.push({name: i, data: data[i]});
            this.school = [...this.school, ...data[i]];
          }
          this.school.forEach((item) => {
            this.schoolids.push(item.collegeName);
          });
        }
      });
    },
    changeadmitBatch() {
      this.selectCollegeList();
    },
    selectCollegeList1() {
      this.dialogTableVisible1 = true;
      this.formInline.admitBatch = this.batch;
      this.schoolids = [];
      this.school = [];
      this.formInline.year = this.user.graduateYear;
      this.formInline.accumulate = this.user.accumulate;
      this.formInline.disciplineType = this.user.disciplineType;
      this.formInline.provinceId = this.user.province;
      this.formInline.current = 1;
      this.formInline.isOptions = 0;
      this.formInline.isMinority = this.user.isMinority;
      this.formInline.isNationalSpecial = this.user.isNationalSpecial;
      this.formInline.isLocalSpecial = this.user.isLocalSpecial;
      this.formInline.colorWeakness = this.user.colorWeakness;
      this.selectCollegeList();
    },
    // 跳页
    handleChange(page) {
      this.formInline.current = page;
      this.selectCollegeList();
    },
    //获取全部高校
    selectCollegeList() {
      selectCollegeList(this.formInline).then((res) => {
        let data = res.data || {};
        this.gridData1 = data.records || [];
        this.recommendCollegeTotal = res.data.total
        if (this.gridData1 && this.gridData1.length > 1) {
          this.admissionYear = this.gridData1[0].admissionYear;
          this.planYear = this.gridData1[0].year;
        }
        this.schooltableData.forEach((item) => {
          this.school = [...this.school, ...item.data];
        });
        this.school.forEach((item) => {
          this.schoolids.push(item.collegeName);
        });
        this.$nextTick(() => {
          this.school.forEach((item) => {
            this.gridData1.forEach((children) => {
              if (
                  children.collegeName == item.collegeName &&
                  children.admitBatch == item.admitBatch
              ) {
                console.log(children, "children");
                this.$refs.eltableCurrentRow.toggleRowSelection(
                    children,
                    true
                );
              }
            });
          });
        });
      });
    },
    //添加学校
    saveServiceOneToOneUniversity() {
      if (!this.school || this.school.length == 0) {
        this.$message.error("请选择学校");
        return;
      }
      let schoollist = [];
      this.school.forEach((item) => {
        schoollist.push({
          scoreLowest: item.scoreLowest ? item.scoreLowest : item.scoreYearThis,
          admitBatch: item.admitBatch,
          universityId: item.universityId,
          collegeName: item.collegeName,
        });
      });
      saveServiceOneToOneUniversity(schoollist, {
        oneId: this.oneid,
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.getServiceOneToOneUniversityPage(this.form.oneId);
          this.dialogTableVisible1 = false;
        }
      });
    },
    //添加专业
    saveServiceOneToOneSpecialty() {
      console.log(this.oneid, "oneid");
      if (!this.chooseSpecialty || this.chooseSpecialty.length == 0) {
        this.$message.error("请选择专业");
        return;
      }
      saveServiceOneToOneSpecialty(this.chooseSpecialty, {
        oneId: this.oneid,
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.getServiceOneToOneSpecialtyList(this.form.oneId);
          this.dialogTableVisible = false;
        }
      });
    },
    //删除学校
    deleteServiceOneToOneUniversity(id) {
      deleteServiceOneToOneUniversity({id: id}).then((res) => {
        if (res.code == 1) {
          this.getServiceOneToOneUniversityPage(this.form.oneId);
        }
      });
    },
    //获取专业列表
    getServiceOneToOneSpecialtyList(id) {
      getServiceOneToOneSpecialtyList({oneId: id}).then((res) => {
        if (res.code == 1) {
          this.checkes = [];
          console.log(res, "专业");
          this.majortableData = res.data || [];
          this.majortableData.forEach((item) => {
            item.specialtys.forEach((child) => {
              this.checkes.push(child.specialtyId);
            });
          });
        }
      });
    },
    selectSpecialtyList() {
      getSpecialtyTree({}).then((res) => {
        if (res.code == 1) {
          this.data = res.data || [];
          this.dialogTableVisible = true;
        }
      });
    },
    // //选择专业
    // handleSelectionChanges(val) {
    //   this.specialty = val;
    //   this.dialogTableVisible = true;
    // },
    //删除专业类
    deleteServiceOneToOneSpecialtyType(disciplineId) {
      deleteServiceOneToOneSpecialtyType({
        disciplineId: disciplineId,
        oneId: this.form.oneId,
      }).then((res) => {
        if (res.code == 1) {
          this.getServiceOneToOneSpecialtyList(this.form.oneId);
        }
      });
    },
    //删除专业
    deleteServiceOneToOneSpecialty(id) {
      deleteServiceOneToOneSpecialty({id: id}).then((res) => {
        if (res.code == 1) {
          this.getServiceOneToOneSpecialtyList(this.form.oneId);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  .edit {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .top {
    padding: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 14px;
    margin-bottom: 10px;

    span {
      margin-right: 20px;
    }
  }

  .tabelinput {
    width: 850px;
  }

  .buttontop {
    float: right;
  }

  .title {
    margin-top: 10px;

    .titleline {
      display: inline-block;
      width: 4px;
      height: 20px;
      margin-right: 10px;
      background-color: #1ab394;
      border-radius: 2px;
      // border: 1px solid rgba(0, 0, 0, 0.2);
    }

    .titletext {
      display: inline-block;
      font-weight: 700;
      color: #000;
      vertical-align: top;
    }
  }

  .table {
    margin-top: 20px;
    margin: 30px;
  }

  .div {
    margin-left: 30px;
    margin-bottom: 30px;
  }

  .span1 {
    display: inline-block;
    padding: 5px 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 5px;
    margin: 0px 10px;
    background-color: #fff9e0;
    color: #ef9a70;
  }

  .span2 {
    display: inline-block;
    padding: 5px 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 5px;
    margin: 0px 10px;
    background-color: #e0faff;
    color: #56c1d6;
  }

  .span3 {
    display: inline-block;
    padding: 5px 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 5px;
    margin: 0px 10px;
    background-color: #e0ffe0;
    color: #65e365;
  }

  .addbutton {
    display: inline-block;
    // margin-left: calc(100% - 110px);
    float: right;
    margin-right: 30px;
  }

  .divspecialtys {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .spanspecialtys {
      min-width: 40px;
      border-radius: 3px;
      height: 20px;
      line-height: 20px;
      margin: 5px;
      padding: 5px;

      // border: 1px solid #e5e5e5;
      color: #000;
      // background-color: #f0f9eb;
    }
  }
}
</style>
